
import { dateFormat } from "@/utils/date";
import { defineComponent, reactive, ref } from "vue";
import { DialogGenre } from "@/interfaces/common.interface";
import { tableConfig, Prop2LabelMap, gyoushuInfo, VIEW_NAME } from "./config";
import useDialog from "@/hooks/useDialog";
import Dialog from "./Dialog.vue";
import { getGyoushuList } from "@/api/kaisha.api";
import { ElMessage } from "element-plus";
import dayjs from "dayjs";
import { ErrorMsg } from "@/constants/message.constant";
import { DatePattern } from "@/constants/common.constant";

// テーブルの各行表示内容

export default defineComponent({
  name: "gyoushu",
  components: {
    Dialog,
  },
  setup() {
    const table = reactive({
      list: [] as gyoushuInfo[],
      total: 0,
      loading: true,
    });

    //検索メイン処理
    const getList = async () => {
      table.loading = true;
      table.list = [];
      const { data } = await getGyoushuList();
      const { listData, total } = data.result;
      table.total = total;
      for (let i = 0; i < listData.length; i++) {
        table.list.push({
          id: listData[i].id,
          gyoushuCd: listData[i].gyoushu_bunrui_cd,
          gyoushuNm: listData[i].gyoushu_bunrui_nm,
          createdDate: dateFormat(listData[i].toroku_date),
          updatedDate: dateFormat(listData[i].koshin_date),
        });
      }
      table.loading = false;
    };

    //ダイアログ利用
    const { dialogTitle, dialogOperation, openDialog } = useDialog(VIEW_NAME);

    //excel出力イベント
    const exportLoading = ref(false);
    const handleExport2excel = async () => {
      try {
        exportLoading.value = true;

        //出力処理
        const { aoaToSheetXlsx } = await import("@/utils/export2Excel"); //lazy load
        aoaToSheetXlsx({
          data: table.list,
          headerMapper: Prop2LabelMap,
          filename: `${dayjs().format(
            DatePattern.SimpleDatePattern
          )}_${VIEW_NAME}リスト.xlsx`,
          exclude: ["id"],
        });
      } catch (error) {
        ElMessage.error(ErrorMsg.ERR_EXPORT_FAIL);
      } finally {
        exportLoading.value = false;
      }
    };

    //初期表示時、一回検索
    getList();

    return {
      table,
      tableConfig,
      getList,
      DialogGenre,
      dialogTitle,
      dialogOperation,
      openDialog,
      exportLoading,
      handleExport2excel,
    };
  },
});
